import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import SubmitChannels from "@/pages/home/components/SubmitChannels";
import ReviewFlow from "@/pages/home/components/ReviewFlow";
import ExposureBoard from "@/pages/home/components/ExposureBoard";
import HotTopics from "@/pages/home/components/HotTopics";
import PrivacyPromise from "@/pages/home/components/PrivacyPromise";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaBand from "@/pages/home/components/CtaBand";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div id="page-top" className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <SubmitChannels />
        <ReviewFlow />
        <ExposureBoard />
        <HotTopics />
        <PrivacyPromise />
        <FaqSection />
        <CtaBand />
      </main>
      <SiteFooter />
    </div>
  );
}